<!-- navItem „Storno“ — Stornodatum und Stornogrund. -->
<div class="cp-provision-contract-cancellation">

    <cp-provision-object-data
            objectType="cp.ProvisionContract"
            [objectId]="provisionContractId"
            widgetAlias="cp.provisionContract.cancellation"
            widgetTitle="Storno"
            [fields]="fields"
            [columns]="columns"
            emptyText="Keine Provisionszeile ausgewählt.">
    </cp-provision-object-data>

</div>
